<template>
  <div class="insurance-companies page-content">
    <section class="module__header">
      <h2 class="module__header__title">合作保险公司</h2>
      <p class="module__header__subtitle">Cooperators Insurance</p>
    </section>
    <section class="table-list">
      <table class="align-left">
        <colgroup>
          <col style="width: 245px" />
          <col style="width: 300px" />
          <col style="width: 179px" />
          <col style="width: 130px" />
          <col style="width: 217px" />
          <col style="width: 130px" />
        </colgroup>
        <thead>
          <th>保险公司</th>
          <th>合作范围</th>
          <th>合作周期</th>
          <th>分支机构</th>
          <th>官方网站</th>
          <th>联系客服</th>
        </thead>
        <tbody>
          <tr v-for="record in dataSource" :key="record.id">
            <td>{{ record.name }}</td>
            <td>{{ record.businessScope }}</td>
            <td>
              {{ record.cooperationCrt }}至<br />{{ record.cooperationEnd }}
            </td>
            <td><a class="link" @click="checkBranch(record)">查看</a></td>
            <td>
              <a
                class="link"
                target="_blank"
                :href="record.linkWebUrl"
                v-if="record.webUrl"
                >{{ record.webUrl }}</a
              >
            </td>
            <td>
              <a class="link" @click="checkServicePhone(record)">查看</a>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="card-list">
      <section class="card" v-for="record in dataSource" :key="record.id">
        <section class="description">
          <span class="label">保险公司</span>
          <section class="value">{{ record.name }}</section>
        </section>
        <section class="description">
          <span class="label">合作范围</span>
          <section class="value">{{ record.businessScope }}</section>
        </section>
        <section class="description">
          <span class="label">合作周期</span>
          <section class="value">
            {{ record.cooperationCrt }}至<br />{{ record.cooperationEnd }}
          </section>
        </section>
        <section class="description">
          <span class="label">分支机构</span>
          <section class="value">
            <a class="link" @click="checkBranch(record)">查看</a>
          </section>
        </section>
        <section class="description">
          <span class="label">官方网站</span>
          <section class="value">
            <a class="link" :href="record.webUrl" v-if="record.webUrl">{{
              record.webUrl
            }}</a>
          </section>
        </section>
        <section class="description">
          <span class="label">联系客服</span>
          <section class="value">
            <a class="link" @click="checkServicePhone(record)">查看</a>
          </section>
        </section>
      </section>
    </section>
    <modal
      v-bind="modalProps"
      @change="updateModalVisible"
      v-model="modalProps.visible"
    >
      <template v-if="modalContent">
        <section v-html="modalContent"></section
      ></template>
      <div v-else class="center-box">
        <Empty text="暂未设置" />
      </div>
    </modal>
  </div>
</template>

<script>
import Modal, { modalMixin } from "@/components/modal";
import Empty from "@/components/Empty.vue";
import { get } from "lodash";
export default {
  name: "insurance-companies",
  components: { Modal, Empty },
  mixins: [modalMixin],
  data() {
    return {
      dataSource: [],
      modalContent: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/base/insurance-company/pcPageList?pageSize=100")
        .then((res) => {
          console.log(res, "res");
          const records = get(res, "data.records");
          this.dataSource = Array.isArray(records)
            ? records.map((record) => {
                const webUrl = record.webUrl;
                if (typeof webUrl === "string" && webUrl.startsWith("www")) {
                  record.linkWebUrl = "https://" + record.webUrl;
                } else {
                  record.linkWebUrl = record.webUrl;
                }
                return record;
              })
            : [];
        })
        .catch((error) => {});
    },
    checkBranch(record) {
      this.modalContent = record.branchInstitution;
      this.updateModalProps({
        visible: true,
        title: "分支机构",
      });
    },
    checkServicePhone(record) {
      this.modalContent = record.hotline;
      this.updateModalProps({
        visible: true,
        title: "联系客服",
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
